// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__7MlhQ","box":"popup_box__QFwMM","header":"popup_header__TtOo3","btnClose":"popup_btnClose__J5ggY","main":"popup_main__MpzBj"};